import Grid from '@material-ui/core/Grid/Grid';
import SimpleTriageCard from 'components/DashboardB/DashboardTriage/SimpleTriageCard';
import { EqualColumns } from 'components/UI';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import { IconType } from 'lmc-ui-library/lib/components/atoms/Icon/Icon.types';
import { CARD_TYPE } from 'pages/DashboardB/DashboardTriage/interfaces';
import React, { ReactElement } from 'react';
import { dashboard } from 'routes/routePaths';
import { PageComponentProps } from 'shared/interface/globalInterface';
import { navigateExternal } from 'utils/navigation/navigation';
import './_Triage.scss';

type TriageCardProps = {
  title: string;
  icon: IconType;
};

type TriageProps = {
  leftTriageCard: TriageCardProps;
  rightTriageCard: TriageCardProps;
};

type TriagePageProps = TriageProps & PageComponentProps;

const Triage: React.FC<TriagePageProps> & PageLayoutParams = ({ history, leftTriageCard, rightTriageCard }) => {
  useBodyClass('light');

  const navigateTo = (path: string = '') => {
    history.push(path);
  };

  const leftPanel = (): ReactElement[] => {
    const column = [
      <SimpleTriageCard
        title={leftTriageCard.title}
        subTitle="GO"
        navigateTo={() => navigateExternal(process.env.REACT_APP_CASES_URL)}
        type={CARD_TYPE.BROKER_PORTAL}
        icon={leftTriageCard.icon}></SimpleTriageCard>,
    ];
    return column;
  };

  const rightPanel = (): ReactElement[] => {
    const column = [
      <SimpleTriageCard
        title={rightTriageCard.title}
        subTitle="GO"
        navigateTo={() => navigateTo(dashboard)}
        type={CARD_TYPE.CASES}
        icon={rightTriageCard.icon}></SimpleTriageCard>,
    ];

    return column;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <EqualColumns columns={[leftPanel(), rightPanel()]} />
      </Grid>
    </Grid>
  );
};

Triage.layout = Layouts.TRIAGE;

export default Triage;
